import InteractiveText from './InteractiveText';

export default InteractiveText;
